import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Breadcrumbs,
  Link,
  Button,
  IconButton,
  Chip,
} from '@mui/material';
import {
  Home as HomeIcon,
  PictureAsPdf as PictureAsPdfIcon,
  OndemandVideo as OndemandVideoIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';


export const TopicsPage = () => {
  const { classId, subjectId, lessonId } = useParams();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await fetch(
          'https://wsmsv1.aidigitalsec.com/api/Student/GetStudyMaterial_Student',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
              classId: parseInt(classId, 10),
              subjectId: parseInt(subjectId, 10),
              lessonId: parseInt(lessonId, 10),
            }),
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch topics');
        }

        const data = await response.json();
        setTopics(Array.isArray(data) ? data : []);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
  }, [classId, subjectId, lessonId]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>

      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#333" }}>
        Topics
      </Typography>

      {topics.length > 0 ? (
        <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Topic</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Resources</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {topics.map((topic) => (
                <TableRow key={topic.topicId} hover>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <DescriptionIcon sx={{ mr: 1, color: 'primary.main' }} />
                      <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                        {topic.topic}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {topic.content || 'No description available'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      {topic.pdfPath && (
                        <Button
                          variant="outlined"
                          startIcon={<PictureAsPdfIcon />}
                          href={`https://wsmsv1.aidigitalsec.com/${topic.pdfPath}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          size="small"
                        >
                          PDF
                        </Button>
                      )}
                      {topic.videoUrlLink && (
                        <Button
                          variant="outlined"
                          startIcon={<OndemandVideoIcon />}
                          href={topic.videoUrlLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          size="small"
                          color="secondary"
                        >
                          Video
                        </Button>
                      )}
                      {!topic.pdfPath && !topic.videoUrlLink && (
                        <Chip label="No resources" color="default" size="small" />
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" color="text.secondary" textAlign="center" mt={4}>
          No topics available.
        </Typography>
      )}
      <Box sx={{ my: 4 }}>
  <Button
    variant="contained"
    startIcon={<ArrowBackIcon />}
    onClick={() => navigate(-1)}
    sx={{
      background: 'linear-gradient(111.1deg, rgba(69,150,164,1) 2.5%, rgba(17,20,34,1) 100.3%)',
      color: '#fff',
      '&:hover': {
        background: 'linear-gradient(111.1deg, rgba(69,150,164,0.9) 2.5%, rgba(17,20,34,0.9) 100.3%)',
      },
    }}
  >
    Back
  </Button>
</Box>

    </Box>
  );
};

export default TopicsPage;
